import { RefObject, useEffect, useState } from 'react';

export const scrollIntoView = (ref: RefObject<HTMLDivElement>) =>
  ref?.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });

const useOnScreen = (ref: RefObject<Element>) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = new IntersectionObserver(([entry]) =>
    setIsIntersecting(entry.isIntersecting || entry.boundingClientRect.top <= 0)
  );

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    observer.observe(ref.current);
    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
};

export default useOnScreen;
